import CoreMessageDispatcher from '../../core/controller/CoreMessageDispatcher';
import CoreEvents from '../../core/events/CoreEvents';
import ComponentEvents from '../../core/events/ComponentEvents';
import {CameraSettings} from '../../settings/camera';
import Tunnel3D from '../tunnel3d/Tunnel3D';

const SizesUtils = require('../../../../viscomjs/utils/SizesUtils');
const small = SizesUtils.winWidth() < 1100;

const _dispatcher = CoreMessageDispatcher.instance();

const _init = mdr => {
    if (mdr.initiated) return mdr;

    mdr.view = Tunnel3D({
        geometryScale: 1,
        camera: CameraSettings,
        fps: small ? 35 : 50
    }).init(mdr.el);

    _dispatcher.emit(ComponentEvents.TUNNEL_3D_READY);

    mdr.initiated = true;
    return mdr;
};

const _start = mdr => {
    if (mdr.started) return mdr;

    mdr._update(true);
    _addCoreListeners(mdr, true);
    mdr.view.addListener('startTransition', mdr._onStartTransition);
    mdr.view.addListener('endTransition', mdr._onEndTransition);
    mdr.view.addListener('cuePoint', mdr._onCuePointTransition);

    mdr.view.start();

    mdr.started = true;
    return mdr;
};

const _stop = mdr => {
    if (!mdr.started) return mdr;

    _addCoreListeners(mdr, false);
    mdr.view.removeAllListeners('startTransition');
    mdr.view.removeAllListeners('endTransition');
    mdr.view.removeAllListeners('cuePoint');

    mdr.started = false;
    return mdr;
};

const _update = (mdr, force) => {
    if (!mdr.started && !force) return mdr;

    mdr.state.isOn = mdr.model.state !== 'loader';

    let state = mdr.model.currentEventId;
    if (state.length < 1) state = mdr.model.state;
    const stateChanged = mdr.state.state !== state && !mdr.model.transitionEvtInProgress;
    mdr.state.state = state;

    const sceneDecorState = mdr.model.currentEventOpened ? 'opened' : mdr.model.currentCoverOpened ? 'visible' : 'hidden';
    const sceneDecorStateChanged = mdr.state.sceneDecorState !== sceneDecorState;
    mdr.state.sceneDecorState = sceneDecorState;

    if (stateChanged || force) {
        //
        mdr.el.dataset.isOn = mdr.state.isOn;
        mdr.el.dataset.state = mdr.state.state;

        // Set 3D state
        mdr.view.setState(mdr.state.state, mdr.model.needCompleteTransition, mdr.model.needTransition);
    }

    if (sceneDecorStateChanged || force) {
        mdr.el.dataset.decorState = mdr.state.sceneDecorState;

        // Set 3D Scene Decoration State
        if (mdr.state.sceneDecorState === 'opened') mdr.view.hideScreen();
        else mdr.view.showScreen();
    }

    return mdr;
};

const _onStartTransition = () => {
    _dispatcher.emit(ComponentEvents.TRANSITION_3D_STARTED);
};

const _onEndTransition = () => {
    _dispatcher.emit(ComponentEvents.TRANSITION_3D_ENDED);
};

const _onCuePointTransition = name => {
    switch (name) {
        case 'zoomIn':
            _dispatcher.emit(ComponentEvents.TUNNEL_3D_AT_LOCATION, name);
            break;
    }
};

//

//
// From Core
//
const _addCoreListeners = (mdr, b) => {
    if (b) {
        _dispatcher.on(CoreEvents.MODEL_STATE_CHANGED, mdr._update);
        _dispatcher.on(CoreEvents.CURRENT_EVENT_STATE_CHANGED, mdr._update);
        _dispatcher.on(CoreEvents.TRANSITION_STATE_CHANGED, mdr._update);
        return;
    }

    _dispatcher.off(CoreEvents.MODEL_STATE_CHANGED, mdr._update);
    _dispatcher.off(CoreEvents.CURRENT_EVENT_STATE_CHANGED, mdr._update);
    _dispatcher.off(CoreEvents.TRANSITION_STATE_CHANGED, mdr._update);
};

//

//
// Constructor
//
const Tunnel3DMediator = (el, model) => {
    const mdr = {
        el: el,
        model: model,
        view: null,
        state: {
            isOn: true,
            state: '',
            needTransition: false
        }
    };

    mdr.start = () => {
        return _start(_init(mdr));
    };

    mdr._update = force => {
        return _update(mdr, force);
    };

    mdr.stop = () => {
        return _stop(mdr);
    };

    mdr._onStartTransition = () => {
        return _onStartTransition(mdr);
    };

    mdr._onEndTransition = () => {
        return _onEndTransition(mdr);
    };

    mdr._onCuePointTransition = name => {
        return _onCuePointTransition(name);
    };

    return mdr;
};

export {Tunnel3DMediator};
export default Tunnel3DMediator;
